module.exports = __webpack_public_path__ + "static/media/masjid_kichula11.f5272a87.webp";